import { Column, Table } from '@odin-labs/components';
import { GetJobsiteConfigZonesQuery } from 'apollo/generated/client-operations';
import React from 'react';

type Zone = NonNullable<
  GetJobsiteConfigZonesQuery['getJobsite']
>['zones'][number];
export type ZoneListItem = Zone;
type ZoneColumn = Column<ZoneListItem>;

const columns: ZoneColumn[] = [
  { id: 'name', Header: 'Name', accessor: 'name' },
];

export function ZoneList({
  zones,
  onSelect,
}: {
  zones: ZoneListItem[];
  onSelect: (zone: ZoneListItem) => void;
}): React.ReactElement {
  return (
    <Table
      columns={columns}
      data={zones}
      onRowClick={({ data: zone }) => onSelect(zone)}
      remote
      disableGlobalFilter
      disableSortBy
    />
  );
}
